export const inventoryBarData1 = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      cv: 4000,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      cv: 3500,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      cv: 3000,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      cv: 2000,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      cv: 1500,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      cv: 1500,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 3090,
      pv: 4300,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 3090,
      pv: 4000,
      cv: 2000,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 4490,
      pv: 2300,
      cv: 1200,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 3490,
      pv: 3200,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
  ];

  export const OMSBarData1 = [
    {
      name: "Jan",
      uv: 1000,
      pv: 200,
      cv: 4000,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      cv: 3500,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      cv: 3000,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      cv: 2000,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      cv: 1500,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      cv: 1500,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 3090,
      pv: 4300,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 3090,
      pv: 4000,
      cv: 2000,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 4490,
      pv: 2300,
      cv: 1200,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 3490,
      pv: 3200,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
  ];
  export const CRMBarData = [
    {
      name: "Jan",
      uv: 1000,
      pv: 200,
      cv: 4000,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      cv: 3500,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      cv: 3000,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      cv: 2000,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      cv: 1500,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      cv: 1500,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 3090,
      pv: 4300,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 3090,
      pv: 4000,
      cv: 2000,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 4490,
      pv: 2300,
      cv: 1200,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 3490,
      pv: 3200,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
  ];
  export const DropShippingBarData = [
    {
      name: "Jan",
      uv: 1000,
      pv: 200,
      cv: 4000,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      cv: 3500,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      cv: 3000,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      cv: 2000,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      cv: 1500,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      cv: 1500,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 3090,
      pv: 4300,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 3090,
      pv: 4000,
      cv: 2000,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 4490,
      pv: 2300,
      cv: 1200,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 3490,
      pv: 3200,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 490,
      pv: 300,
      cv: 3200,
      amt: 2100,
    },
  ];
  export const BIBarData = [
    {
      name: "Jan",
      uv: 1000,
      pv: 200,
      cv: 4000,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      cv: 3500,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      cv: 3000,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      cv: 2000,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      cv: 1500,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      cv: 1500,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 3090,
      pv: 4300,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 3090,
      pv: 4000,
      cv: 2000,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 4490,
      pv: 2300,
      cv: 1200,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 3490,
      pv: 3200,
      cv: 2200,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3490,
      pv: 4300,
      cv: 3200,
      amt: 2100,
    },
  ];